export async function mockUpload(
  _file: { file: File },
  onProgress?: (progress: number) => void
): Promise<{ documentId: string }> {
  return new Promise((resolve) => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += Math.random() * 15;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
        onProgress?.(100);
        setTimeout(() => resolve({ documentId: '123' }), 200);
      } else {
        onProgress?.(progress);
      }
    }, 400);
  });
}
